import { AdminToolCommonModal } from "./AdminToolCommonModal";
import { useState, useRef } from "react";
import useAdminHttp from "../../hooks/useAdminHttp";
import { message, Select, Button } from "antd";

const MakeAccountOwnerButton = ({ record, accountOwnerDataRef, customerResData, setCustomerResData }) => {
  const [transferOwnershipModalVisible, setTransferOwnershipModalVisible] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [transferOwnershipButtonLoading, setTransferOwnershipButtonLoading] = useState(false);
  const chosenUserRecordRef = useRef(null);
  const { fetchData } = useAdminHttp();

  const openTransferOwnershipModal = (userRecord) => {
    chosenUserRecordRef.current = userRecord;
    // there is no role id 1 if this leaves as null it become 0 in the backend so set it to 1
    setSelectedRole(accountOwnerDataRef.current ? null : 1);
    setTransferOwnershipModalVisible(true);
  };

  const closeTransferOwnershipModal = () => {
    setTransferOwnershipModalVisible(false);
    setSelectedRole(null);
  };

  const handleChangeAccountOwner = () => {
    setTransferOwnershipButtonLoading(true);
    fetchData(`accounts/${chosenUserRecordRef.current?.osyncId}/transfer-ownership`, "put", {
      newOwnerOsyncUserId: chosenUserRecordRef.current?.osyncUserId,
      currentOwnerNewRoleId: selectedRole,
    })
      .then((response) => {
        if (response?.data) {
          setCustomerResData((prevCustomerResData) => {
            return {
              ...prevCustomerResData,
              account: response?.data,
            };
          });
          message.success("Account Owner Changed Successfully");
        } else {
          message.error("Error no data was returned");
        }
      })
      .catch((error) => {
        message.error("Error in changing account owner or partially changed");
      })
      .finally(() => {
        setTransferOwnershipButtonLoading(false);
        setTransferOwnershipModalVisible(false);
        setSelectedRole(null);
        chosenUserRecordRef.current = null;
      });
  };

  const ModalBody = () => {
    return (
      <div className="container-fluid px-3 mt-2">
        <div className="mb-4">
          <h5 className="fw-semibold text-dark mb-2">Transfer Account Ownership</h5>
          {accountOwnerDataRef.current ? (
            <p>
              Choose the role for current account owner <u>{accountOwnerDataRef.current?.email}</u> after the account ownership transferred to{" "}
              <u>{chosenUserRecordRef.current?.email}</u>.
            </p>
          ) : (
            <p>No account owner found for this account.</p>
          )}
        </div>
        {accountOwnerDataRef.current && (
          <div>
            <Select
              className="w-100"
              placeholder="New role for current owner"
              onChange={(value) => setSelectedRole(value)}
              value={selectedRole}
              options={customerResData?.roles?.map((role) => ({
                label: role?.roleName,
                value: role?.roleId,
              }))}
            />
          </div>
        )}
        <div className="d-flex justify-content-end gap-2 border-top pt-4">
          <Button className="mt-2 row-reverse d-inline-block w-100 h-45 hs-fs-14" onClick={closeTransferOwnershipModal}>
            Cancel
          </Button>
          <Button
            className="ms-3 mt-2 row-reverse d-inline-block w-100 h-45"
            type="primary"
            onClick={handleChangeAccountOwner}
            disabled={!selectedRole}
            loading={transferOwnershipButtonLoading}
          >
            Transfer Ownership
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={"d-flex align-items-center w-100 cursor-pointer"}
        onClick={() => {
          openTransferOwnershipModal(record);
        }}
      >
        <div className="actionIconsSprite account-owner-icon" />
        <span className="hs-fs-12">Make Account Owner</span>
      </div>
      <AdminToolCommonModal
        width={480}
        body={<ModalBody />}
        open={transferOwnershipModalVisible}
        modalIcon={<div className="actionIconsSprite account-owner-change-icon" />}
      />
    </>
  );
};

export default MakeAccountOwnerButton;
